export const home = {
	className: 'icon-home',
	viewBox: '0 0 144.122 185.76501',
	paths: ['m 144.121,185.764 -22.172,0 0,-128.29 -49.779,-31.273 -0.008,0.007 -0.111,-0.068 -49.879,31.335 0,128.29 L 0,185.765 0,45.193 71.971,0 l 0.621,0.39 5.469,3.324 66.061,41.479 0,140.571 z']
}
